import { Pipe, PipeTransform } from '@angular/core';
import { MenuLink } from '../interfaces/menu-link.model';
import { LinkType } from '../enums/link-type.enum';

@Pipe({
  name: 'linkType'
})
export class LinkTypePipe implements PipeTransform {

  transform(value: MenuLink[], args: LinkType): any {
    return value.filter(link => link.linkType === args);
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/link-type.pipe.ts